{
  "title": "SOR Registry",
  "subtitle": "Carbon Credit Management",
  "memberSubtitle": "Project Developer Dashboard",
  "welcome": "Welcome",
  "login": "Login",
  "logout": "Logout"
}